import VitalityGroup from '@/utils/classes/VitalityCategory/VitalityGroup';
// DMP criteria
import VCriterionMeetingOnSchedule from './meetingOnSchedule';
import VCriterionMeetingParticipants from './meetingParticipants';
import VCriterionMeetingRating from './meetingRating';
import VCriterionMeetingDuration from './meetingDuration';
import VCriterionIndicRecurrence from './redIndicatorRecurrence';
import VCriterionIndicPbWhenRed from './indicatorProblemsWhenRed';
import VCriterionIndicOutliers from './indicatorOutliers';
import VCriterionActionNumber from './actionNumber';
import VCriterionActionLeadTime from './actionLeadTime';
import VCriterionActionPostpmt from './postponements';
// Previous criteria now removed
// import VCriterionIndicPb from './indicatorProblems';



export default new VitalityGroup({
  key: 'dmp',
  dataInfo: [
    {
      serverUrl: '/server/meetings/get.php',
      specDataKey: 'meetings',
      dataTeamKey: 'team',
    },
    {
      serverUrl: '/server/meetings/plannings/get.php',
      specDataKey: 'plannings',
      dataTeamKey: 'team',
    },
    {
      serverUrl: '/server/indicators/get.php',
      specDataKey: 'themes',
      dataTeamKey: 'team',
    },
    {
      serverUrl: '/server/actions/get.php',
      specDataKey: 'actions',
      dataTeamKey: 'affectTeam',
    },
  ],
  titleTr: 'DMP',
  weight: 3,
  criteria: [
    VCriterionMeetingOnSchedule,
    VCriterionMeetingParticipants,
    VCriterionMeetingRating,
    VCriterionMeetingDuration,
    VCriterionIndicRecurrence,
    VCriterionIndicPbWhenRed,
    VCriterionIndicOutliers,
    VCriterionActionNumber,
    VCriterionActionLeadTime,
    VCriterionActionPostpmt,
  ],
});
